// extracted by mini-css-extract-plugin
export default {"container2":"Modules_container2__Z+IE-"};